var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgConfigDelete(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 12,
    viewBox: "0 0 12 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2.66663 12C2.29996 12 1.98607 11.8694 1.72496 11.6083C1.46385 11.3472 1.33329 11.0333 1.33329 10.6667V2H0.666626V0.666667H3.99996V0H7.99996V0.666667H11.3333V2H10.6666V10.6667C10.6666 11.0333 10.5361 11.3472 10.275 11.6083C10.0138 11.8694 9.69996 12 9.33329 12H2.66663ZM9.33329 2H2.66663V10.6667H9.33329V2ZM3.99996 9.33333H5.33329V3.33333H3.99996V9.33333ZM6.66663 9.33333H7.99996V3.33333H6.66663V9.33333Z",
    fill: "#8B8D97"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgConfigDelete);
export default __webpack_public_path__ + "static/media/configDelete.189fe8d4721dec9094c4c1bf0a9d83c2.svg";
export { ForwardRef as ReactComponent };